import { createSlice } from '@reduxjs/toolkit';

const groupIdSlice = createSlice({
  name: 'groupId',
  initialState: { groupId: null },
  reducers: {
    setGroupId: (state, action) => {
      state.groupId = action.payload;
    },
    clearGroupId: (state) => {
      state.groupId = null;
    },
  },
});

export const { setGroupId, clearGroupId } = groupIdSlice.actions;
export default groupIdSlice.reducer;
